/* eslint-disable no-underscore-dangle */
import SearchClient from '../search';

export default class MacoClient extends SearchClient {
  constructor(options = {}) {
    super(options);
  }

  getPermisosMaco = async (data) => {
    try {
      const response = await this.request('get')(
        { data },
        { path: 'maco/permisos' },
      );
      return response.data;
    } catch (error) {
      return error.response;
    }
  }
}
